import styled from 'styled-components';

export const VerifyContainer = styled.div`
display: flex;
width: 100%;
height: 100vh;
min-height: 800px;
`;

export const VerifyWrapper = styled.div`
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
max-width: 1400px;
width: 100%;
margin-left: auto;
margin-right: auto;
padding: 25px;
`;

export const VerifyImage = styled.img`
width: 100%;
height: auto;
max-width: 150px;
`;

export const VerifyHeader = styled.h3`
font-size: 24px;
margin-top: 25px;
`;

export const VerifyText = styled.p`
font-size: 18px;
margin-top: 25px;
text-align: center;
`;

export const ResendButton = styled.button`
font-size: 18px;
color: #33682c;
width: fit-content;
height: fit-content;
padding: 10px;
background: none;
border: none;

&:hover {
    transition: all 0.2s ease-in-out;
    cursor: pointer;
    transform: scale(1.05);
}
`;

export const VerifyDivider = styled.div`
width: 100%;
border-bottom: 1px solid #F0F0F0;
margin-top: 25px;
margin-bottom: 25px;
`;
